export default function IconTrashBin({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M27.5 6.41699L25.1847 28.4063C25.1187 29.0341 24.8227 29.6153 24.3536 30.0379C23.8846 30.4604 23.2758 30.6944 22.6444 30.6948H9.35556C8.72403 30.6948 8.11487 30.4609 7.64557 30.0383C7.17626 29.6157 6.88005 29.0343 6.81406 28.4063L4.5 6.41699H27.5Z"
        fill="#E4F1F5"
      />
      <path d="M27.0962 10.2503L27.5 6.41699H4.5L4.90378 10.2503H27.0962Z" fill="#C1D4D9" />
      <path
        d="M27.5 6.41699L25.1847 28.4063C25.1187 29.0341 24.8227 29.6153 24.3536 30.0379C23.8846 30.4604 23.2758 30.6944 22.6444 30.6948H9.35556C8.72403 30.6948 8.11487 30.4609 7.64557 30.0383C7.17626 29.6157 6.88005 29.0343 6.81406 28.4063L4.5 6.41699H27.5Z"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.30469 6.41699H30.6936"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.25 6.41678V2.58344C10.25 2.24455 10.3846 1.91955 10.6243 1.67992C10.8639 1.44029 11.1889 1.30566 11.5278 1.30566H20.4722C20.8111 1.30566 21.1361 1.44029 21.3757 1.67992C21.6154 1.91955 21.75 2.24455 21.75 2.58344V6.41678"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 12.167V25.5837"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7502 12.167L21.1113 25.5837"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.25 12.167L10.8889 25.5837"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
